<template>
  <div>
    <!-- <div class="row justify-content-between align-items-center">
        <div class="col-md-6 customHeading">
          <h3>{{moduleName}}</h3>
        </div>
        <div class="col-md-3" >
          <b-form-group  label="" label-for="datepicker-2" autocomplete="off" style = "margin-bottom: 0px;" >
            <b-form-datepicker id="datepicker-2" v-model= "FromDate" @input="getGraphData()" placeholder="Choose Start Date"
               :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" local="en">
               </b-form-datepicker>
          </b-form-group>
        </div>
         <div class="col-md-3">
          <b-form-group  label="" style = "margin-bottom: 0px;" label-for="datepicker-1" autocomplete="off">
            <b-form-datepicker id="datepicker-1" v-model= "ToDate" placeholder="Choose End Date" @input="getGraphData()" 
              :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" local="en">
              </b-form-datepicker>
          </b-form-group>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
        </div>
    </div> -->

    <div class="com-header">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label=""
                  label-for="datepicker-2"
                  autocomplete="off"
                  style="margin-bottom: 0px;"
                >
                  <b-form-datepicker
                    id="datepicker-2"
                    v-model="FromDate"
                    @input="getGraphData()"
                    placeholder="Choose Start Date"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'long',
                      day: '2-digit',
                    }"
                    local="en"
                  >
                  </b-form-datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-datepicker
                  id="datepicker-1"
                  v-model="ToDate"
                  placeholder="Choose End Date"
                  @input="getGraphData()"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  }"
                  local="en"
                >
                </b-form-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <div style="width:70%;margin:auto;margin-top:5%">
      <DetailBarGraph
        v-if="graphData != null"
        :chartData="graphData"
        :options="graphOptions"
      ></DetailBarGraph>
    </div>
    <Spinner
      v-if="isLoading"
      message="Loading..."
      size="medium"
      line-fg-color="rgb(222 224 219"
      line-bg-color="rgb(68 66 62)"
    >
    </Spinner>
    <div v-if="graphData == null && !isLoading" style="text-align:center">
      <b style="color:red">No data found</b>
    </div>
    <Toaster ref="toaster" />
  </div>
</template>
<script>
// import VueCharts from 'vue-chartjs'
import DetailBarGraph from "./detail-bar-graph";
import axios from "axios";
import Toaster from "../toaster";
import Spinner from "vue-simple-spinner";
export default {
  name: "ShipmentDetailGraph",
  components: {
    DetailBarGraph,
    Toaster,
    Spinner,
  },
  data() {
    return {
      moduleName: "Shipment Detailed Graphical Report",
      graphData: null,
      graphOptions: Object,
      FromDate: new Date(),
      ToDate: new Date(),
      isLoading: true,
    };
  },
  mounted() {
    this.FromDate = new Date(
      this.FromDate.getFullYear(),
      this.FromDate.getMonth(),
      1,
      this.FromDate.getHours()
    );
    this.ToDate = new Date(
      this.ToDate.getFullYear(),
      this.ToDate.getMonth() + 1,
      0,
      this.ToDate.getHours()
    );
    this.graphOptions = {
      responsive: true,
      maintainAspectRatio: false,
      title: { display: true, text: "Shipment Detailed Chart" },
      legend: {
        display: true,
        position: "right",
      },
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "Flour Types",
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function(label) {
                if (label >= 1000) {
                  return (label / 1000).toLocaleString() + " K";
                } else {
                  return label.toLocaleString();
                }
              },
            },
          },
        ],
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem, data) {
            if (tooltipItem.xLabel >= 1000) {
              return (
                "Sacks: " +
                (tooltipItem.xLabel / 1000).toLocaleString() +
                "K" +
                " (" +
                data.datasets[tooltipItem.datasetIndex].label +
                ")"
              );
            } else {
              return (
                "Sacks: " +
                tooltipItem.xLabel.toLocaleString() +
                " (" +
                data.datasets[tooltipItem.datasetIndex].label +
                ")"
              );
            }
          },
        },
      },
    };
    this.getGraphData();
  },
  methods: {
    getGraphData() {
      this.isLoading = true;
      axios
        .post("/productionreport/GetShipmentDetailedGraphData", {
          FromDate: this.FromDate,
          ToDate: this.ToDate,
          CompanyId: this.$auth.user().companyId,
        })
        .then((res) => {
          //   console.log(res)
          this.isLoading = false;
          if (res.data.status == 1) {
            this.graphData = res.data.data;
          } else if (res.data.status == -1) {
            this.$refs.toaster.showToast("Error", "danger", res.data.msg);
          } else {
            this.graphData = null;
          }
        });
    },
  },
};
</script>

<style scoped>
.custom-row {
  overflow: visible !important;
}
.form-group {
  margin-bottom: 0.4rem;
}

.b-form-btn-label-control.form-control {
  width: 270px;
  /* width: 110%; */
}
.nav-tabs {
  font-size: 22px !important;
  border-bottom: none !important;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-bottom: 2px solid transparent !important;
}
.customHeading {
  margin-bottom: 1px;
}
</style>
